import React from 'react';

function ContentPage() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Content Brief</h1>
      <p>This is the content brief page. Add your content here.</p>
    </div>
  );
}

export default ContentPage;
